/**
 * @generated SignedSource<<2ec22ae8633f4c48a7428bd9fd592d10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendEmailInput = {
  clientMutationId?: string | null;
  email: string;
  personalizedEmailTemplateId: string;
};
export type sendEmailButton_SendEmailMutation$variables = {
  input: SendEmailInput;
};
export type sendEmailButton_SendEmailMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly sendEmail: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type sendEmailButton_SendEmailMutation = {
  response: sendEmailButton_SendEmailMutation$data;
  variables: sendEmailButton_SendEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Email",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SendEmailPayload",
            "kind": "LinkedField",
            "name": "sendEmail",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendEmailButton_SendEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendEmailButton_SendEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "417348d32171b5471b9d467db1094c64",
    "id": null,
    "metadata": {},
    "name": "sendEmailButton_SendEmailMutation",
    "operationKind": "mutation",
    "text": "mutation sendEmailButton_SendEmailMutation(\n  $input: SendEmailInput!\n) {\n  Admin {\n    Email {\n      sendEmail(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2df9a71345dfad5eb2c74305731eb47";

export default node;
